import React from "react";
import { FormattedMessage } from "react-intl";
/**
 * CZNA-1591 — realm czna's password rules, shown before the administrator types: Keycloak
 * would otherwise be the first to tell, one rule per attempt. The text lists the rules in
 * the order the form checks them (validationUtils PASSWORD_RULES).
 */
var PasswordRulesHint = function (_a) {
    var id = _a.id;
    return (React.createElement("p", { id: id, style: { marginTop: 0, color: "#666" } },
        React.createElement(FormattedMessage, { id: "ui-czna-users.users.password.rules" })));
};
export default PasswordRulesHint;
